import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    lastname: yup.string().required('Campo obligatorio'),
    firstname: yup.string().required('Campo obligatorio'),
    email: yup.string().required('Campo obligatorio'),
  })
  .required()
